document.addEventListener('DOMContentLoaded', function() {
// Function to check if the current page URL matches "/reserveren/"
function isReserverenPage() {
    // return window.location.pathname === '/reserveren/';
    return window.location.pathname === '/reserveer/';
}

// Function to refresh the page with an alert message
function refreshPage() {
    // Display an alert message
    alert("U was te lang inactief, deze pagina ververst zich nu automatisch.");
    // Reload the page
    window.location.reload();
}

// Initialize the inactivity timer if on the "/reserveren/" page
if (isReserverenPage()) {
    // Set the inactivity timeout duration in milliseconds (1h in this case)
    const inactivityTimeout = 3600000; // 1h
    let timeoutId;

    // Function to reset the timer
    function resetTimer() {
        // console.log("Timer reset!")
        clearTimeout(timeoutId);
        timeoutId = setTimeout(refreshPage, inactivityTimeout);
    }

    // Add event listeners to monitor user activity
    document.addEventListener('mousemove', resetTimer);
    document.addEventListener('keydown', resetTimer);

    // Add touch event listeners for mobile devices
    document.addEventListener('touchstart', resetTimer);
    document.addEventListener('touchmove', resetTimer);

    // Start the initial timer
    resetTimer();
}
})